var map = {
	"./back.svg": "7338",
	"./cross.svg": "2ad7",
	"./entertainment.svg": "b5e8",
	"./feedback.svg": "eaaf",
	"./home.svg": "ac9d",
	"./important.svg": "0c39",
	"./lock.svg": "9619",
	"./logo.svg": "5b1c",
	"./loupe.svg": "f39b",
	"./microphone.svg": "4eb8",
	"./minus.svg": "3e24",
	"./mute.svg": "11df",
	"./open.svg": "b167",
	"./photo.svg": "7e86",
	"./play.svg": "dab1",
	"./plus.svg": "eb38",
	"./point.svg": "7c2f",
	"./refund.svg": "3e83",
	"./replic.svg": "8757",
	"./smile_bad.svg": "f6e0",
	"./smile_fine.svg": "c2aa",
	"./smile_great.svg": "01e5",
	"./spectacle.svg": "940a",
	"./success.svg": "1c27",
	"./thanks.svg": "4a58",
	"./theatre.svg": "1825",
	"./tickets.svg": "bda2",
	"./voice.svg": "f313",
	"./volume.svg": "8901"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";